import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TableComponent } from './table.component';
import { SortableColumnDirective } from './sortable-column.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [TableComponent, SortableColumnDirective],
  exports: [TableComponent, SortableColumnDirective]
})
export class TableModule {}
